import { useState } from 'react'
import { useLanguage } from '@/hooks/useLanguage'
import { useIsDesktop } from '@/hooks/useIsDesktop'
import { authT } from '../../locale'

export const AuthIllustration = () => {
  const { language } = useLanguage()
  const isDesktop = useIsDesktop()
  const l = authT[language]
  const [videoReady, setVideoReady] = useState(false)

  if (!isDesktop) return null

  return (
    <div className="lg:flex lg:flex-1 p-6">
      <div
        className="relative w-full h-full rounded-[26px] p-[2px]"
        style={{
          background:
            'linear-gradient(to bottom right, rgba(201,160,255,0.25), rgba(166,108,255,0.25), rgba(123,63,228,0.25))',
        }}
      >
        <div className="relative w-full h-full rounded-3xl overflow-hidden bg-[#1a1620]">
          <div
            aria-hidden
            className={`absolute inset-0 animate-pulse transition-opacity ease-out ${
              videoReady ? 'opacity-0' : 'opacity-100'
            }`}
            style={{
              transitionDuration: '700ms',
              animationDuration: '2.4s',
              background:
                'linear-gradient(135deg, rgba(201,160,255,0.20) 0%, rgba(166,108,255,0.20) 50%, rgba(123,63,228,0.20) 100%)',
            }}
          />
          <video
            src="/videos/loginPreview.mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            onCanPlay={() => setVideoReady(true)}
            onError={() => setVideoReady(true)}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-out ${
              videoReady ? 'opacity-100' : 'opacity-0'
            }`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          <div className="absolute bottom-12 left-12 right-12">
            <h2 className="text-2xl font-semibold text-white leading-tight">
              {l.bannerLine1}
              <br />
              {l.bannerLine2}
            </h2>
          </div>
        </div>
      </div>
    </div>
  )
}
